const getUserDetailResponse = (response) => {
  const { user } = response || {};

  const isHost = user?.role?.isHost;
  const firstBrand = user?.brands?.[0];
  const hostBrand = firstBrand ? { value: firstBrand.id, label: firstBrand.name } : null;
  const multiBrands = user?.brands?.map((brand) => ({ value: brand.id, label: brand.name })) || [];

  return {
    id: user?.id,
    name: user?.name,
    email: user?.email,
    handphone: user?.handphone,
    address: user?.address,
    domicile: user?.domicile,
    isLdap: user?.isLdap,
    isLive: user?.isLive,
    isActive: user?.isActive,
    gender: user?.gender ? { value: user.gender, label: user.gender } : null,
    nik: user?.nik,
    nip: user?.nip,
    joinDate: user?.joinDate,
    terminateDate: user?.terminateDate,
    baId: user?.baId,
    role: user?.role ? { value: user.role.id, label: user.role.name, isHost: user.role.isHost } : null,
    brand: isHost ? hostBrand : multiBrands,
    ecommerces: user?.ecommerces?.map((ecommerce) => ({ value: ecommerce.id, label: ecommerce.name })) || [],
    organization: user?.organization,
  };
};

export default getUserDetailResponse;
